import { Like } from '@depop/web-thrift-ui/Illustrations/Like';
import { useTranslations } from 'next-intl';

import { SignupGateModal } from '@/components/SignupGateModal';

type Props = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
};

export function GuestLikesModal({ isOpen, setOpen }: Props) {
  const t = useTranslations('common');

  return (
    <SignupGateModal
      id="guest-likes-modal"
      isOpen={isOpen}
      setOpen={setOpen}
      title={t('GuestLikesModal.Title')}
      description={t('GuestLikesModal.Description')}
      illustration={<Like size="large" />}
      trackingId="guest-likes"
      redirectParam={encodeURIComponent('/[username]/likes/')}
      //   handleSignupClick={handleSignupClick} - implement in WEB-9313
    />
  );
}
